import React, {useEffect, useState} from 'react';
import './scss/asset-view.scss';
import Api from "../services/api";
import {Button} from 'react-bootstrap';
import AssetExtendProp from "./properties/asset-extend";
import FullScreenLoader from "./full-screen";
import ReactJson from 'react-json-view';
import SandraJsAPI from "../services/sandraJsAPI";
import {StatusMessageTypeEnum} from "../enums/StatusMessageTypeEnum";

function AssetExtend({setStatusMessage, assetId, extendedAsset}: AssetExtendProp): React.ReactElement {

    const [extendedAssetString, setExtendedAssetString] = useState("");
    const [jsonUrl, setJsonUrl] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const onBeautify = () => {
        setStatusMessage("", StatusMessageTypeEnum.none);
        if (extendedAssetString.trim().length == 0) return;
        let minify = extendedAssetString.replace(/(\r\n|\n|\r)/gm, "");
        try {
            let minifyJson = JSON.parse(minify)
            setExtendedAssetString(JSON.stringify(minifyJson, undefined, 1));
        } catch (e) {
            setStatusMessage("Invalid json", StatusMessageTypeEnum.error);
            window.scrollTo(0, 0);
        }
    };

    const loadExtendedData = () => {
        setStatusMessage("", StatusMessageTypeEnum.none);
        if (jsonUrl.trim().length > 0) {
            setIsLoading(true);
            Api.getMetaData("/proxy?target=" + jsonUrl)
                .then(res => {
                    setIsLoading(false);
                    setExtendedAssetString(JSON.stringify(res));
                }).catch(error => {
                setStatusMessage(error.message, StatusMessageTypeEnum.error);
                setIsLoading(false);
                window.scrollTo(0, 0);
            });
        }
    }

    const onSave = () => {
        setStatusMessage("", StatusMessageTypeEnum.none);
        setIsLoading(true);
        SandraJsAPI.saveExtendedAsset(assetId, (extendedAssetString)).then(res => {
            if (res.error?.status) {
                setStatusMessage(res.error.message, StatusMessageTypeEnum.error);
            } else if (res.data) {
                setStatusMessage('Asset updated, please reload the asset to check updates.', StatusMessageTypeEnum.success);
            } else {
                setStatusMessage('Unable to update asset', StatusMessageTypeEnum.error);
            }
            setIsLoading(false);
            window.scrollTo(0, 0);
        }).catch(error => {
            setStatusMessage(error.message, StatusMessageTypeEnum.error);
            setIsLoading(false);
            window.scrollTo(0, 0);
        });
    };

    useEffect(() => {
    }, []);

    return (
        <div className="pt-3">
            {isLoading ? <FullScreenLoader/> : <div/>}
            <h5>Current Extended Asset Data</h5>
            <ReactJson src={JSON.parse(extendedAsset || '{}')}
                       style={{
                           fontSize: '12px',
                           fontFamily: 'monospace',
                           backgroundColor: 'rgb(255 231 231)',
                           width: '100%',
                           padding: '1rem',
                           wordBreak: 'break-all'
                       }} collapsed
                       theme="apathy:inverted"/>
            <h5 className="pb-0 pt-3">Update/Add Extended Asset Data</h5>

            <div className="pb-1"><strong className="pb-0">New JSON</strong></div>
            <div className="pt-2 pb-2 text-end d-none">
                <div className="row">
                    <div className="col-9">
                        <input
                            type="text"
                            id="jsonUrl"
                            style={{fontSize: '12px', fontFamily: 'monospace'}}
                            className="form-control"
                            value={jsonUrl}
                            onChange={(e) => setJsonUrl(e.target.value)}
                        />
                    </div>
                    <div className="col-3">
                        <Button variant="primary"
                                style={{fontSize: '12px', fontFamily: 'monospace', width: '100%'}}
                                onClick={loadExtendedData}>
                            Load JSON from Url
                        </Button>
                    </div>
                </div>

            </div>
            <textarea
                id="extendedAsset"
                className="form-control"
                value={(extendedAssetString)}
                style={{fontSize: '12px', fontFamily: 'monospace'}}
                rows={12}
                onChange={(e) => setExtendedAssetString((e.target.value))}
            />
            <p className="small-label pt-3" style={{fontFamily: "inherit"}}><strong className="pe-1">Note:</strong>
                On saving system will create a triplet with verb as "has" and target as "extendedData", json
                given above will be flattened and stored as references attached to this triplet.
            </p>
            <div className="pt-2 pb-2 text-end">
                <Button variant="secondary me-2" onClick={onBeautify} style={{}}>
                    Beautify JSON
                </Button>
                <Button variant="primary" onClick={onSave}>
                    Save
                </Button>
            </div>

        </div>
    );

}

export default AssetExtend;
